module.exports = {
  TheExpiredAndNoCreated: ' The contract of the consignor has expired and no more business can be created!',
  NotTheCorrectOperationStatus: ' Not in the correct operation status.',
  NoDataSelected: ' No data selected',
  AllAreInNonStatus: ' All selected data records are in non-"normal operation" status',
  ThisSelfConsolidationBuyerConsolidation: ' This bill type is not self-consolidation, buyer consol, or consignor consolidation',
  AttachmentContentTooLarge: ' Attachment content too large',
  AreWantToWithdrawBill: ' Are you sure you want to withdraw this bill?',
  SplitOrder: ' Split order',
  MergeOrder: ' Merge order',
  SRIFailedPleaseContactTroubleshooting: ' SRI entrustment order push failed, please contact staff for troubleshooting:',
  OperationSuccessful: ' Operation successful',
  ContainerType: ' Container type',
  LockedPrintedPleaseContactUnlocking: ' Locked and cannot be printed, please contact supervisor for unlocking!',
  FullContainerProfitPrint: ' Full-container profit print',
  LCLProfitPrint: ' LCL profit print',
  NoSubTicketSelected: ' No sub-ticket selected',
  CustomersSuchAsPOEtc: ' Customer\'s own numbers for shipping freight, such as PO NBR, ITEM NBR, etc.',
  OriginalBillOfLading: ' Original Bill of Lading',
  TelexRelease: ' Telex Release',
  NoLoadingInformationSelected: ' No loading information selected',
  PleaseASubTicketRecord: ' Please select a sub-ticket record',
  PleaseSelectAContainer: ' Please select a container',
  BillOfLadingInformationTracking: ' Bill of Lading information tracking',
  ReleaseNumber: ' Release Number:',
  Unknown: ' Unknown',
  ViewExceptions: ' View exceptions',
  PleaseSelectDesignatedData: ' Please select designated data',
  LicenseOfLadingNumberEmpty: ' License plate number and bill of lading number cannot be empty',
  NoRelevantInformationAvailable: ' No relevant information available',
  DoToDeleteTheTicket: ' Do you want to delete the sub-ticket?',
  AuditSuccessful: ' Audit successful',
  Allocation: ' Allocation',
  ChangeOrders: 'Change orders',
  ImportManifest: 'Import manifest'
}
